module.exports = __webpack_public_path__ + "static/media/sqlite.ed34606e.svg";